import { render, staticRenderFns } from "./ApexRadarCharts.vue?vue&type=template&id=eb4af890"
import script from "./ApexRadarCharts.vue?vue&type=script&lang=js"
export * from "./ApexRadarCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports